module.exports = "<a\n  href=\"https://www.iubenda.com/privacy-policy/7763734\"\n  class=\"iubenda-nostyle no-brand iub-body-embed iubenda-embed\"\n  title=\"Privacy Policy\">\n  Privacy Policy\n</a>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./policies/privacy-policy.html
 ** module id = 394
 ** module chunks = 0
 **/